module.exports = __webpack_public_path__ + "static/img/d-5.f8c96dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-5.png
// module id = Whip
// module chunks = 1